import { render, staticRenderFns } from "./DetailGroupItemGallery.vue?vue&type=template&id=20ee356d&"
import script from "./DetailGroupItemGallery.vue?vue&type=script&lang=js&"
export * from "./DetailGroupItemGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports